// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-rows fieldset{
    top: 0 !important;
}
.input-rows .MuiOutlinedInput-root{
    margin-left: 0 !important;
}
.input-columns .MuiSelect-outlined{
    padding: 25px 32px 25px 10px;
}
/* .input-rows input{
    height: 37px;
} */
.draggable-row{
    gap: 20px;
}
.delete-btn{
    margin: auto 0;
    width: 35px;
    flex-shrink: 0;
}
.delete-btn button{
    min-width: 35px;
    min-height: 35px;
}
.drag-text-size {
    font-size: 14px !important;
}
.normal-buttons {
    width: 160px;
    height: 50px;
    border-radius: 4px;
}
.endpoit-name-column{
    flex-direction: row !important;
    align-items: center;
}

.MuiCalendarPicker-root .MuiPickersDay-today {
  border: 2px solid #3f51b5 !important;
  background-color: transparent !important;
  font-weight: bold !important;
}

.MuiCalendarPicker-root .MuiPickersDay-today:not(.Mui-disabled) {
  color: #3f51b5 !important;
}`, "",{"version":3,"sources":["webpack://./src/css/custom.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,4BAA4B;AAChC;AACA;;GAEG;AACH;IACI,SAAS;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".input-rows fieldset{\n    top: 0 !important;\n}\n.input-rows .MuiOutlinedInput-root{\n    margin-left: 0 !important;\n}\n.input-columns .MuiSelect-outlined{\n    padding: 25px 32px 25px 10px;\n}\n/* .input-rows input{\n    height: 37px;\n} */\n.draggable-row{\n    gap: 20px;\n}\n.delete-btn{\n    margin: auto 0;\n    width: 35px;\n    flex-shrink: 0;\n}\n.delete-btn button{\n    min-width: 35px;\n    min-height: 35px;\n}\n.drag-text-size {\n    font-size: 14px !important;\n}\n.normal-buttons {\n    width: 160px;\n    height: 50px;\n    border-radius: 4px;\n}\n.endpoit-name-column{\n    flex-direction: row !important;\n    align-items: center;\n}\n\n.MuiCalendarPicker-root .MuiPickersDay-today {\n  border: 2px solid #3f51b5 !important;\n  background-color: transparent !important;\n  font-weight: bold !important;\n}\n\n.MuiCalendarPicker-root .MuiPickersDay-today:not(.Mui-disabled) {\n  color: #3f51b5 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
